import { ThemeSwitcher } from "@/components/header/theme-switcher";
import { useTheme } from "@/providers/theme-wrapper";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
  component: AuthLayout,
  beforeLoad: ({ context }) => {
    if (context.auth?.session?.active_signin && !context.auth?.loading) {
      // console.log("redirecting to dashboard from auth layout");
      throw redirect({
        to: "/dashboard",
        replace: true,
      });
    }
  },
});

function AuthLayout() {
  //   const { isLoaded, isSignedIn } = useAuth();

  //   if (!isLoaded) {
  //     return <FullscreenLoader />;
  //   }

  //   if (isSignedIn) {
  //     return Navigate({ to: "/dashboard" });
  //   }

  return (
    <>
      <ThemeSwitcherButton />
      <Outlet />
    </>
  );
}

const ThemeSwitcherButton = () => {
  const { theme, setTheme } = useTheme();
  return (
    <div className="absolute top-4 right-4 z-50">
      <ThemeSwitcher value={theme} onChange={setTheme} />
    </div>
  );
};
